import { Component, ViewChild } from '@angular/core';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { SessionService } from '../../../Util/Session/session.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { min, Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ExpenseFormItemComponent } from '../expense-form-item/expense-form-item.component';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { Toast, ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ExpenseSubmitFormComponent } from '../expense-submit-form/expense-submit-form.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ThumbnailAttachmentComponent } from '../../../Component/thumbnail-attachment/thumbnail-attachment.component';

@Component({
  selector: 'app-expense',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, NgbDatepickerModule, LoaderComponent, FormsModule,ThumbnailAttachmentComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './expense.component.html',
  styleUrl: './expense.component.scss'
})
export class ExpenseComponent {
  isDisabled: boolean = false;
  mindate = null as any;
  TableDatas = [] as any;
  TableDatasMain = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    ESS_ExpenseReportRequestId: null,
    ESS_TripMasterId: null,
    SelectType: 'ER',
    EmpMasterId: null,
    TravelType: 'Local',
    ESS_ExpenseRequestMainId: null,
    ESS_ExpenseRequestDetailsId: null,
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    Type: 'All'
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private session: SessionService,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    protected sanitizer: DomSanitizer,
  ) {
    this.common.getPageRights();
    this.Filter.EmpMasterId = session.GetUserDetails().UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ExpenseRequest_ComboLoad('GetSubmittedFromDate');
    this.SelectDate('RegistrationDate', null, null);
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if ((moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY')))) {
        this.GetDailyAttendanceInOutHistory();
      } else {
        this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetDailyAttendanceInOutHistory() {
    this.isDisabled = true;
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.expense.ESS_ExpenseRequest_SelectGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.TableDatasMain = response.Table1;
          this.TableDatasMain.forEach((element: any) => {
            if (element.Attachment != null && element.Attachment != '') {
              element.Attachment = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + element.Attachment
            }
          });
          this.FilterData();
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addItem() {
    const modalRef = this.modalService.open(ExpenseFormItemComponent, { size: 'lg', backdrop: 'static', });
    modalRef.componentInstance.TravelType = 'Local';
    modalRef.result.then(
      (result: any) => {
        if (result != undefined && result) {
          this.GetDailyAttendanceInOutHistory();
        }
      },
      () => { }
    );
  }

  CheckSubmit() {
    if (this.TableDatas.filter((e: any) => e.IsCheck).length > 0) {
      if (this.mindate == null || this.mindate == '' || (moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.mindate), 'DD MMM YYYY')))) {
        const modalRef = this.modalService.open(ExpenseSubmitFormComponent, { backdrop: 'static', });
        modalRef.componentInstance.TravelType = 'Local';
        modalRef.componentInstance.Ids = this.TableDatas.filter((e: any) => e.IsCheck).map((e: any) => e.ESS_ExpenseRequestDetailsId).toString();
        modalRef.componentInstance.FromDateObj = this.Filter.FromDateObj;
        modalRef.componentInstance.ToDateObj = this.Filter.ToDateObj;

        modalRef.result.then(
          (result: any) => {
            if (result != undefined && result) {
              this.GetDailyAttendanceInOutHistory();
            }
          },
          () => { }
        );
      } else {
        this.toast.show({ message: "Minimum from date " + this.dateFormat.format(this.mindate), type: toastTypeEnum.danger });
      }
    } else {
      this.toast.show({ message: 'Please check atleast one item', type: toastTypeEnum.warning });
    }
  }

  Delete(id: any) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want delete?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.expense.ESS_ExpenseRequestInsert({ SelectType: 'D', ESS_ExpenseRequestDetailsId: id }).subscribe({
          next: (response) => {
            if (response.Error_Code == "482") {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.GetDailyAttendanceInOutHistory();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  CheckAll(event: any) {
    this.TableDatas.forEach((element: any) => {
      element.IsCheck = event.target.checked;
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          if (this.Filter.FromDateObj == null || this.Filter.FromDateObj == '') {
            this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
            this.Filter.FromDateObj.day = 1;
          }
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          //this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();

          this.GetDailyAttendanceInOutHistory();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }

  FilterData() {
    this.TableDatas = Object.values([]);
    
    if (this.Filter.Type == 'All') {
      this.TableDatas = this.TableDatasMain;
    } else if (this.Filter.Type == 'Category') {
      this.TableDatas = this.TableDatasMain.filter((e: any) => e.ESS_ExpenseCategoryMasterId != null && e.ESS_ExpenseCategoryMasterId != '' && e.ESS_ExpenseCategoryMasterId > 0);
    } else if (this.Filter.Type == 'Vehicle') {
      this.TableDatas = this.TableDatasMain.filter((e: any) => e.ESS_VehicleMasterId != null && e.ESS_VehicleMasterId != '' && e.ESS_VehicleMasterId > 0);
    } else {
      this.Clear();
    }
    this.TableDatas = Object.values(this.TableDatas);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });

  }

  Clear() {
    this.TableDatas = Object.values([]);
    this.TableDatasMain = Object.values([]);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  ESS_ExpenseRequest_ComboLoad(SelectType: String) {
    this.isDisabled = true;
    this.expense.ESS_ExpenseRequest_ComboLoad({ SelectType: SelectType, EmpMasterId: this.Filter.EmpMasterId, TravelType: this.Filter.TravelType }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (response.Table[0].ReportSubmitDate != "" && response.Table[0].ReportSubmitDate != null) {
            this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].ReportSubmitDate);
            this.mindate = this.dateFormat.parse(response.Table[0].ReportSubmitDate);
          }
        }
        this.SelectDate('RegistrationDate', null, null);
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.SelectDate('RegistrationDate', null, null);
        this.isDisabled = false;
      },
    });
  }

  calRequestAmountTotal() {
    return this.TableDatas.map((e: any) => e.ExpenseAmount != '' && e.ExpenseAmount != null && e.IsCheck ? parseFloat(e.ExpenseAmount) : 0).reduce((acc: any, cur: any) => acc + cur, 0);
  }
}
